import { ConfirmActionTheme, FloatingConfirmAction, IconButton } from '@avantstay/backoffice-core'
import { IconEdit, IconTrash } from '@avantstay/backoffice-vectors'

import * as S from './NoteActions.styles'

interface NoteActionsProps {
  isDisabled: boolean
  onEdit: () => void
  onDelete: () => void
}

export const NoteActions = ({ isDisabled, onEdit, onDelete }: NoteActionsProps) => {
  return (
    <S.Root>
      <IconButton.Neutral
        type="button"
        label="Edit note"
        aria-label="Edit note"
        icon={<IconEdit />}
        disabled={isDisabled}
        onClick={onEdit}
      />

      <FloatingConfirmAction
        closeOnScroll
        title="Delete this note?"
        message="This can't be undone."
        cancelText="Cancel"
        confirmText="Delete"
        theme={ConfirmActionTheme.danger}
        placement="bottom-end"
        onConfirm={onDelete}
      >
        <IconButton.Neutral
          type="button"
          label="Delete note"
          aria-label="Delete note"
          icon={<IconTrash />}
          disabled={isDisabled}
        />
      </FloatingConfirmAction>
    </S.Root>
  )
}
